export function isValidInt(value: string): boolean {
    try {
        const BN = BigInt(value).toString();
        return /^-?\d+$/.test(BN);
    } catch (e) {
        // eslint-disable-next-line
        console.error('Is invalid int');
        return false;
    }
}

export function isValidFloat(value: string): boolean {
    return /^-?\d+\.\d+$/.test(value);
}

export function isValidDecimal(value: number): boolean {
    return !isNaN(value) && value >= 0;
}
